import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC } from 'react'

import { partnerBasicInfoFields } from '../../../../../configs'
import { LocationsAndCount } from '../../../../locationsAndCount/LocationsAndCount'

import styles from './BranchesEditMode.module.scss'

interface IBranchesEditModeProps {
  isApplicable: boolean
  count: Nullable<number>
  locations: string
  isCountEnabled?: boolean
  isLocationsEnabled?: boolean
}

export const BranchesEditMode: FC<IBranchesEditModeProps> = ({
  isApplicable,
  count,
  locations,
  isCountEnabled,
  isLocationsEnabled,
}) => {
  return (
    <div className={styles.root}>
      <LocationsAndCount
        isApplicable={isApplicable}
        count={count}
        countFieldName={partnerBasicInfoFields.branchesCount}
        locations={locations}
        locationsFieldName={partnerBasicInfoFields.branchesLocations}
        isCountEnabled={isCountEnabled}
        isLocationsEnabled={isLocationsEnabled}
      />
    </div>
  )
}
